import { Box } from '@hover/blueprint';
import type { ReactNode, TransitionEventHandler } from 'react';
import React from 'react';

type CarouselTransformProps = {
  children: ReactNode;
  onTransitionEnd?: TransitionEventHandler;
  transform?: string;
  transition?: string;
};

const CarouselTransform = ({
  children,
  onTransitionEnd,
  transform,
  transition,
}: CarouselTransformProps) => (
  <Box
    display="block"
    onTransitionEnd={onTransitionEnd}
    transform={transform}
    transition={transition}
    whiteSpace="nowrap"
    width="100%"
  >
    {children}
  </Box>
);

export { CarouselTransform };
